import { FC } from "react";
import { Folder } from "../Folder/Folder";
import styles from "./FolderList.module.sass";
import { IFolder } from "toolkit/documents/folders/types";

interface FolderListProps {
	title: string;
	folders: IFolder[];
}

export const FolderList: FC<FolderListProps> = ({ title, folders }) => {
	return (
		<div className={styles["folders-item"]}>
			<span className={styles["folders-item-title"]}>{title}</span>
			<ul className={styles.list}>
				{folders.map((folder: IFolder) => (
					<Folder key={folder.id} folder={folder} />
				))}
			</ul>
		</div>
	);
};
